import type { SpacesLoad } from '@/store/useUserStore'
import type { WorkbenchAppFilter } from './types'

/** 工作台一块列表的展示：骨架、已有内容、空、失败 */
export type WorkbenchBlockPhase = 'skeleton' | 'content' | 'empty' | 'error'

/**
 * 当前查询已经成功过就继续展示那份结果（刷新中也不换成转圈）。
 * 还没有这份结果时：加载中出骨架，失败出错误空态。
 */
export function workbenchBlockPhase(input: {
  spacesLoad: SpacesLoad
  spaceReady: boolean
  settled: boolean
  error: boolean
  hasItems: boolean
}): WorkbenchBlockPhase {
  if (input.spacesLoad === 'error') return 'error'
  if (!input.spaceReady) return input.spacesLoad === 'pending' ? 'skeleton' : 'empty'
  if (input.settled) return input.hasItems ? 'content' : 'empty'
  if (input.error) return 'error'
  return 'skeleton'
}

/** 缓存属于当前账号才可以拿来静默展示。换账号后的旧结果不能接着画。 */
export function isOwnedWorkbenchSnapshot(
  snapshotUserId: string | undefined,
  userId: string | undefined,
): boolean {
  return Boolean(userId) && snapshotUserId === userId
}

/** 失败标记也属于当前账号、且就是这次查询，才显示错误空态。 */
export function isCurrentWorkbenchFailure(
  failureUserId: string | undefined,
  failureKey: string | undefined,
  userId: string | undefined,
  queryKey: string | null,
): boolean {
  return (
    queryKey != null &&
    failureKey === queryKey &&
    isOwnedWorkbenchSnapshot(failureUserId, userId)
  )
}

/** 应用列表的查询身份。语言不在里面：切语言沿用当前卡片，静默替换。 */
export function workbenchAppsQueryKey(input: {
  spaceId: string
  filter: WorkbenchAppFilter
  keyword: string
  page: number
}): string {
  return [input.spaceId, input.filter, input.keyword, String(input.page)].join('\0')
}
